import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/range-date-event/detail/`;

const GetAllDate = async (weekId) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const response = await fetch(`${uri}get-all?rangeDateEvent=${weekId}`, {
        method: "get",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const UpdatePostingTime = async (
  id,
  date,
  StartingTime,
  EndingTime,
  weekId
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("date", date);
      formData.append("timeBegin", StartingTime);
      formData.append("timeEnd", EndingTime);
      formData.append("status", 1);
      formData.append("rangeDateEventId", weekId);
      const response = await fetch(`${uri}update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};
const AddPostingTime = async (date, timeBegin, timeEnd, rangeDateEventId) => {
  try {
    const role = getRole();
    if (role) {
      const token = role.token;
      const formData = new FormData();
      formData.append("date", date);
      formData.append("timeBegin", timeBegin);
      formData.append("timeEnd", timeEnd);
      formData.append("status", 1);
      formData.append("rangeDateEventId", rangeDateEventId);
      const response = await fetch(`${uri}detail`, {
        method: post,
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

export { GetAllDate, UpdatePostingTime, AddPostingTime };
